import type { LogoBlock } from '@ps/web-martech-cms-types/SiteFooter';
import { Link } from '@ps/web-shared-components';
import classNames from 'clsx';
import { camelCase } from 'lodash';
import React from 'react';

import { CMSImage } from '@swf/cms';

import styles from './Logos.scss';

interface Props {
  logos: LogoBlock[];
}

const Logos: React.FC<Props> = ({ logos }) => (
  /* eslint-disable react/jsx-no-target-blank */
  <div className={styles.logos}>
    {logos.map(({ url: href, class: className, image }, index) => (
      <Link
        href={href}
        style={
          !image?.asset?.url
            ? { backgroundImage: `url('//s4.rationalcdn.com/img/bg/estate/footer-small.png')` }
            : undefined
        }
        className={classNames(styles.logo, {
          [styles[camelCase(className) as keyof typeof styles]]: className && !image?.asset?.url,
          [styles.imageContainer]: image?.height || image?.width
        })}
        target="_blank"
        key={index}
      >
        {image?.asset?.url && (
          <CMSImage {...image} className={!image?.height ? styles.image : ''} />
        )}
        <span>{className}</span>
      </Link>
    ))}
  </div>
  /* eslint-enable */
);

export default Logos;
